export class ShowSectorByIdUseCase{
  constructor(repository) {
    this.repository = repository
  }
  async execute(ID){
    const sector= await this.repository.showBySectorId(ID)
    return sector
  }
}
